
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
@Component({
    components: {},
})
export default class ModalLinkProgressChat extends Vue {
    modalShow = false;
    ticket: any | null = null;
    userDetail = UserModule.userDetail;

    activemenu: Activemenumodel = {
        assesment: 0,
        additional_resource: 0,
        work_order_feedback: 0,
        work_order_history: 0,
        work_order_activity: 0,
        chat: 0,
    };

    showModal(ticket: any, activemenu: Activemenumodel) {
        if (this.userDetail.accessgroup["name"] == "User") {
            const show_history = ticket.work_order_id == null ? 0 : 1;
            // console.log(ticket);
            this.activemenu = {
                assesment: 0,
                additional_resource: 0,
                work_order_feedback: show_history,
                work_order_history: show_history,
                work_order_activity: 0,
                chat: 1,
            };
        } else {
            activemenu['work_order_activity'] = 1;
            this.activemenu = activemenu;
        }
        this.ticket = ticket;
        this.modalShow = true;
    }
    openMenu(page: string) {
        // Save scroll position before navigation
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        sessionStorage.setItem('homeScrollPosition', scrollPosition.toString());
        
        // Emit event to parent to save state
        this.$emit('beforeNavigation');
        
        this.modalShow = false;
        let theId = this.ticket.id;
        if (this.userDetail.accessgroup["name"] == "User") {
            theId = this.ticket.id;
            if(page.includes("feedback") || page.includes("history")) theId = this.ticket.work_order_id
        } else {
            theId = page.includes("chat")
                ? this.ticket.ticket_id
                : this.ticket.id;
        }
        this.$router.push({ path: page + theId });
    }
}

class Activemenumodel {
    assesment: number | undefined;
    additional_resource: number | undefined;
    work_order_feedback: number | undefined;
    work_order_history: number | undefined;
    work_order_activity: number | undefined;
    chat: number | undefined;
}
